module.exports = __webpack_public_path__ + "static/media/image_prd_2.94ab3631.png";